import React, { FC, useEffect } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLazyQuery } from '@apollo/client';
import { getOrderFilesUrlTemplate } from 'apollo/templates/order';
import { File as DenthubFile } from 'models/file';
import FileUploadedTable from 'components/shared/file-uploaded-table/file-uploaded-table.component';

type DownloadFilesDialogProps = {
    orderId: string;
    open: boolean;
    onClose: () => void;
};

type OrderFilesUrlQueryResult = {
    order: {
        _id: string;
        filesUrl: DenthubFile[];
    };
};

const DownloadFilesDialog: FC<DownloadFilesDialogProps> = ({ orderId, open, onClose }: DownloadFilesDialogProps) => {
    const { t: translate } = useTranslation(['common', 'orders']);

    const [fetchOrderFiles, { data, loading }] = useLazyQuery<OrderFilesUrlQueryResult>(getOrderFilesUrlTemplate, {
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (open && orderId) {
            void fetchOrderFiles({ variables: { orderId } });
        }
    }, [open, orderId, fetchOrderFiles]);

    const files = data?.order?.filesUrl ?? [];

    return (
        <Dialog maxWidth="lg" fullWidth open={open} onClose={onClose}>
            <DialogTitle>{translate('orders:DOWNLOAD_FILES')}</DialogTitle>
            <DialogContent>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <FileUploadedTable
                        files={files}
                        hideDelete={true}
                        onDeleteFile={() => null}
                        onImageClick={() => null}
                    />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{translate('common:CLOSE')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DownloadFilesDialog;
